import React from 'react';
import '../ui/ds.css';

/**
 * Loading indicator.
 * size="sm": inline 16px spinner (safe inside buttons).
 * size="md" | "lg" | "full" (default md): centred block with an optional message.
 */
const LoadingSpinner = ({ size = 'md', message, className = '' }) => {
    if (size === 'sm') {
        return <span className={`ds-spinner ds-spinner--sm ${className}`} role="status" aria-label={message || 'Loading'} />;
    }
    return (
        <div className={`ds-loading ${size === 'lg' || size === 'full' ? 'ds-loading--lg' : ''} ${className}`} role="status" aria-live="polite">
            <span className="ds-spinner" aria-hidden="true" />
            <span className="ds-loading__text">{message || 'Loading…'}</span>
        </div>
    );
};

export default LoadingSpinner;
